---
title: 'Step 3: Install the Collector'
install_track_title: Installation Guide (Amazon RDS and Amazon Aurora)
backlink_href: /docs/install
backlink_title: 'Installation Guide'
---

import SetupIAMPolicy from './_03_setup_iam_policy.mdx';
import CreateIAMRole from './_03_create_iam_role.mdx';
import CollectorInstallInstructions from "../../components/CollectorInstallInstructions"

import imgRdsNewInstanceRole from "../../images/rds_new_instance_role.png"

export const ImgRdsNewInstanceRole = () => <img src={imgRdsNewInstanceRole} width="694.4" />

## Installing the collector on an Amazon EC2 Instance

For this step, you first need to choose whether you want to install the collector on an existing EC2 instance, or run a new one.

The [pganalyze collector](https://github.com/pganalyze/collector) is a daemon process that continuously collects database statistics, and submits them to the pganalyze dashboard in recurring intervals.

You can either run it on a small instance (a `t3.small` suffices), or add it to an existing EC2 instance in your environment.

<SetupIAMPolicy />

<CreateIAMRole />

If you are going to use the existing EC2 instance, attach the created IAM role to the EC2 instance.

### Start a new EC2 instance

Start a new `t3.small` instance, Amazon Linux 2 based, that has the created IAM role applied:

<p>
  <ImgRdsNewInstanceRole />
</p>

Then follow the step to install the collector on Amazon Linux 2 based instances.


### Install the collector on the instance

<CollectorInstallInstructions apiKey={props.apiKey} />

After successful installation the pganalyze collector will now be running in the background on your instance.

<Link className="btn btn-success" to="04_configure_the_collector_ec2">
  Proceed to Step 4: Configure the Collector
</Link>
